import React from "react";
import { styleBlogTables } from "../../utils/styleBlogTables";
import { processBlogHtml } from "../../utils/processBlogHtml";

const TABLE_CSS = `
.azzir-blog-content .azzir-blog-table-wrap {
  width: 100%;
  overflow-x: auto;
  margin: 20px 0 16px;
}
.azzir-blog-content table {
  width: 100% !important;
  border-collapse: collapse !important;
  table-layout: fixed !important;
  display: table !important;
  border: 1px solid #111 !important;
}
.azzir-blog-content th,
.azzir-blog-content td {
  border: 1px solid #111 !important;
  padding: 10px 12px !important;
  vertical-align: top !important;
  word-break: break-word !important;
}
.azzir-blog-content th p,
.azzir-blog-content td p {
  margin: 0 !important;
}
.azzir-blog-content tbody tr:first-child th,
.azzir-blog-content tbody tr:first-child td,
.azzir-blog-content thead th {
  background: #1a1a1a !important;
  color: #fff !important;
  font-weight: 700 !important;
}
.azzir-blog-content tbody tr:first-child th *,
.azzir-blog-content tbody tr:first-child td *,
.azzir-blog-content thead th * {
  color: #fff !important;
}
.azzir-blog-content img {
  max-width: min(100%, 640px) !important;
  max-height: 360px !important;
  width: auto !important;
  height: auto !important;
  margin: 16px auto !important;
  display: block !important;
  object-fit: contain !important;
}
`;

const BlogContent = ({ content, blocks = [] }) => {
  if (typeof content === "string" && content.trim()) {
    const html = processBlogHtml(styleBlogTables(content));
    return (
      <>
        <style>{TABLE_CSS}</style>
        <div
          className="azzir-blog-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </>
    );
  }

  const items = Array.isArray(content) ? content : blocks;
  if (!items.length) return null;

  return (
    <div className="azzir-blog-content">
      {items.map((block, index) => {
        const key = `${block.type}-${index}`;

        switch (block.type) {
          case "h2":
            return <h2 key={key}>{block.text}</h2>;
          case "h3":
            return <h3 key={key}>{block.text}</h3>;
          case "p":
            return <p key={key}>{block.text}</p>;
          case "ul":
            return (
              <ul key={key}>
                {(block.items || []).map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            );
          case "ol":
            return (
              <ol key={key}>
                {(block.items || []).map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ol>
            );
          case "img":
            return (
              <figure key={key} className="azzir-blog-content__figure">
                <img src={block.src} alt={block.alt || ""} loading="lazy" />
                {block.caption ? <figcaption>{block.caption}</figcaption> : null}
              </figure>
            );
          case "quote":
            return <blockquote key={key}>{block.text}</blockquote>;
          default:
            return null;
        }
      })}
    </div>
  );
};

export default BlogContent;
